<template>
    <div>
        <Popup v-model="popupShow" @close="close" style="width: 90%">
            <p class="first-title">请选择操作</p>
            <p class="second-title">请选择执行的操作</p>
            <div style="margin-top:30px;display: flex; justify-content:space-around">
                <p style="font-size: 16px;color: #21242a" @click="close">取消</p>
                <p style="font-size: 16px;color: #f5222d" @click="deleteDevice">删除</p>
                <p style="font-size: 16px;color: #1890ff" @click="showDevice">查看</p>
            </div>
        </Popup>
    </div>
</template>

<script>
    import {Popup, NavBar, Field, Dialog,Button} from "vant"


    export default {
        components: {Popup, Field, Button, Dialog,NavBar,},
        props: {
            item: {type: Object, required: true},
            type: {type: String, default: "default"},
            show: {type: Boolean, default: false}
        },
        data() {
            return {
                popupShow: false,
            };
        },
        computed: {},
        created() {
            this.popupShow = this.show
        },
        mounted() {
        },
        methods: {
            close() {
                this.$emit('panel', this.type,)
            },
            deleteDevice(){
                Dialog.confirm({
                    message: '确定删除该设备吗?',
                }).then(()=>{
                    this.$toast.loading("正在处理中...")
                    this.$http.tokiot.device.delete({id: this.item.id})
                        .then(res => {
                            if (res) {
                                this.$toast.success("删除成功")
                                this.popupShow = !this.popupShow
                                this.$emit("onRefresh")
                            } else {
                                this.$toast.fail(res.message)
                            }
                        })
                        .catch(() => {
                            // on cancel
                        });
                })

            },
            showDevice(){
                this.$router.push('/device/detail/' + this.item.id+'/'+this.item.productType)
            }
        },
        watch: {
            show(show) {
                this.popupShow = show
            },

        }
    }
</script>

<style lang="less" scoped>
    .first-title {
        margin-left: 20px;
        margin-top: 20px;
        font-size: 20px;
    }

    .second-title {
        margin-left: 20px;
        font-size: 18px;
    }
    .button{
        font-size: 16px;
        color: #5a13e4;
    }
</style>